// Store module
const user = {
  state: {
    id: undefined,
    name: 'Unknow',
  },
  getters: {},
  mutations: {},
  actions: {
    loadChannelsByUserId() {
      return true;
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/User.js